import React from 'react';
import clsx from 'clsx';

import styles from './ProgressBar.module.scss';

export type ProgressBarProps = {
  className?: string;
  total: number;
  current: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ className, total, current }) => (
  <div className={clsx(styles.root, className)}>
    <div className={styles.progress} style={{ width: `${(100 / total) * current}%` }} />
  </div>
);
